import React from "react";
import { ChevronRight } from "lucide-react";
import Sparkline from "./Sparkline";

/** VO2max on the Progress page (#203); tap for every estimate and its source. */
const Vo2maxCard = ({ vo2max, approximate, onOpen }) => {
  if (!vo2max?.headline) return null;
  const points = (vo2max.sheet.rows || []).map((r) => ({ value: Number(r.vo2max.value) }));
  const note = vo2max.bike
    ? vo2max.bike.count > 1
      ? `Middle of your last ${vo2max.bike.count} rides`
      : "From one ride"
    : vo2max.air?.current
      ? "Air bike, calibrated to your 2k"
      : "From your 2k";
  return (
    <button
      type="button"
      onClick={onOpen}
      aria-label="VO2max details"
      className="grid gap-2 rounded-2xl border border-border bg-card p-3.5 text-left"
    >
      <span className="flex items-center justify-between gap-2">
        <span className="text-[15px] font-bold text-white">VO2max</span>
        <ChevronRight className="h-4 w-4 text-muted-foreground" />
      </span>
      <span className="flex items-end gap-3">
        <span className="text-2xl font-semibold tabular-nums">
          {approximate ? "About " : ""}
          {vo2max.headline}
        </span>
        <span className="pb-1 text-xs text-muted-foreground">ml/kg/min</span>
        <span className="min-w-0 flex-1 pb-1">
          <Sparkline points={points} />
        </span>
      </span>
      <span className="text-xs text-muted-foreground">{note}</span>
    </button>
  );
};

export default Vo2maxCard;
